/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum HistoricoParticipacoesAliases {
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  CUSTOM_CARD_HISTORICO_PARTICIPACOES = 'custom-card-historico-participacoes',
  DECK_0 = 'deck-0',
  FETCH_0 = 'fetch-0',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_2 = 'field-2',
  FIELD_3 = 'field-3',
  HPMS_DYNAMIC_CONTENT_FIELD_STATUS = 'hpms-dynamic-content-field-status',
  LAYOUT_HISTORICO_PARTICIPACOES = 'layout-historico-participacoes',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
  TEXT_3 = 'text-3',
}
export { HistoricoParticipacoesAliases };
